import { Directive, ElementRef, EventEmitter, Injector, Input, Output } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
   // tslint:disable-next-line:directive-selector
   selector: 'am-edit-timeslip-button'
})
export class EditTimeslipButtonUpgradedDirective extends UpgradeComponent {
   @Input() id: string;
   @Output() refresh: EventEmitter<any>;

   constructor(elementRef: ElementRef, injector: Injector) {
      super('amEditTimeslipButton', elementRef, injector);
   }
}
